module.exports = __webpack_public_path__ + "static/fonts/GodoM.e69131e.otf";